"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENTITY_FRAGMENT_NAMES = void 0;
exports.ENTITY_FRAGMENT_NAMES = ["default", "update", "card", "list", "mutation", "table", "summary", "list"];